<a *ngIf="show"
   target="_blank"
   [href]="link"
   [class.top-shadow]="hasTopShadow"
   [class.hide-background]="!showBackground"
   [ngStyle]="{ borderRadius: borderRadius }">
  <h3>{{ title }}</h3>
  <img alt="Logo" [src]="logo">
</a>
